export default class ProspectSourceDomainService {
    static fromJSON(json) {
        return Object.assign(Object.assign({}, json), { modifiedDate: new Date(json.modifiedDate), createdDate: json.createdDate && new Date(json.createdDate) });
    }
}
